/**
 * Hide duplicate date headers in the post feed
 * Only shows date headers when the date changes
 */
function handleDateHeaders() {
    const dateHeaders = document.querySelectorAll('.gh-date-header-compare');
    let prevDate = null;

    // Get the first date header's date
    const firstHeader = document.querySelector('.gh-date-header:not(.gh-date-header-compare)');
    if (firstHeader) {
        prevDate = firstHeader.getAttribute('data-date');
    }

    dateHeaders.forEach((header) => {
        const currentDate = header.getAttribute('data-date');
        
        if (currentDate === prevDate) {
            // Hide duplicate date headers
            header.style.display = 'none';
        } else {
            // Show date header when date changes
            header.style.display = 'block';
            prevDate = currentDate;
        }
    });
}

export default function initDateHeaders() {
    // Run on page load
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', handleDateHeaders);
    } else {
        handleDateHeaders();
    }

    // Also run after infinite scroll loads new content
    document.addEventListener('postsLoaded', handleDateHeaders);
}

